import { render } from "./ReleaseNotesPage.vue?vue&type=template&id=6ef2b24e&scoped=true&ts=true"
import script from "./ReleaseNotesPage.vue?vue&type=script&lang=ts"
export * from "./ReleaseNotesPage.vue?vue&type=script&lang=ts"

import "./ReleaseNotesPage.vue?vue&type=style&index=0&id=6ef2b24e&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef2b24e"]])

export default __exports__